module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921111149_T.0f3fd85e.jpg";